// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Services
import { CoreService } from '../../../shared/services/core.service';
import { AppCleanup } from '../../../shared/models';

// Models
import { DistrictViewModel } from '../models/district-view.model';
import { DistrictDetailViewModel } from '../models/district-detail-view.model';
import { DistrictUnitAddDto } from '../models/district-unit-add-dto.model';
import { UnitViewModel } from '../../asset/unit/models/unit-view.model';
import { DistrictUserAddDto } from '../models/district-user-add-dto.model';
import { UserModel } from '../../../shared/models/user-model.model';
import { DistrictUserViewModel } from '../models/district-user-view.model';

@Injectable({
	providedIn: 'root',
})
export class DistrictService extends AppCleanup {
	private districtUrl;

	constructor(private http: HttpClient) {
		super();
		this.districtUrl = `${this.apiUrl}api/district`;
	}

	getDistricts() {
		return this.http.get<DistrictViewModel[]>(this.districtUrl);
	}

	getDistrict(id: number) {
		return this.http.get<DistrictDetailViewModel>(`${this.districtUrl}/${id}`);
	}

	addUnitsToDistrict(model: DistrictUnitAddDto) {
		return this.http.post<UnitViewModel[]>(`${this.districtUrl}/unit`, model);
	}

	addUsersToDistrict(model: DistrictUserAddDto) {
		return this.http.post<DistrictUserViewModel[]>(`${this.districtUrl}/user`, model);
	}

	deleteDistrictFromUnit(unitId: number) {
		return this.http.delete<UnitViewModel>(`${this.districtUrl}/unit/${unitId}`);
	}

	deleteUserFromDistrict(districtUserId: number) {
		return this.http.delete<UserModel>(`${this.districtUrl}/user/${districtUserId}`);
	}
}
